import { isParameter } from "typescript";

const request = async (url: string, method: string, body?: any, p0?: string) => {
    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
        body: body ? JSON.stringify(body) : undefined,
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error('Error en la petición');
    }

    return response.json();
};

//Registrar entidad "uso general"
export const registrarEntidad = (url: string, cve: string, nombre: string) => {
    const body = { cve, nombre };
    return request(url, 'POST', body);
};

//Obtener entidad "uso general"
export const obtenerEntidades = (url: string) => {
    return request(url, 'GET');
};

//Actualizar entidad "uso general"
export const actualizarEntidad = (url: string, nombre: string, id_linea?: number) => {
    const body = id_linea ? { nombre, id_linea } : { nombre };
    return request(url, 'PATCH', body);
};

// Actualizar proveedor - función específica para proveedores
export const actualizarProveedor = (url: string, id: string, nombre: string) => {
    // Aquí modificamos el body para que coincida con lo que espera tu API
    const body = { id, nombre };
    return request(url, 'PATCH', body);
};

// Actualizar Usuario "No se está usando"
export const actualizarEntidadUsuario = (url: string, data: { nombre: string; usuario: string; password: string }) => {
    return request(url, 'PATCH', data);
};

//Eliminar entidad "uso general"
export const eliminarEntidad = (url: string) => {
    return request(url, 'DELETE');
};

//Registrar Entidad "uso general"
export const registrarEntidadId = (url: string, id: string, nombre: string, usuario: string, contraseña: string, telefono?: string) => {
    const body = { id, nombre, usuario, contraseña, telefono };
    return request(url, 'POST', body);
};

//Actualizar Usuario
export const actualizarEntidadUsuarioId = (url: string, id: string, nombre: string, usuario: string, contraseña: string, telefono?: string) => {
    const body = { id, nombre, usuario, contraseña, telefono };
    return request(url, 'PATCH', body);
};

//Registrar Sucursal
export const registrarEntidadSu = (url: string, id: string, nombre: string, ip: string) => {
    const body = { id, nombre, ip };
    return request(url, 'POST', body);
};

//Eliminar Usuario
export const eliminarUsuario = (url: string) => {
    return request(url, 'DELETE');
};

//Eliminar Sucursal
export const eliminarSucursal = (url:string) => {
    return request(url, 'DELETE');
};

//Actualizar Sucursal
export const actualizarEntidadSucursalId = (url: string, id: string, nombre: string, ip: string) => {
    const body = {id, nombre, ip};
    return request(url, 'PATCH', body);
};

// Obtener las líneas
export const obtenerLineas = (url: string) => {
    return request(url, 'GET');
};

// Registrar sublínea
export const registrarSublinea = (url: string, cve: string, nombre: string, cve_linea: string) => {
    const body = {cve_linea, cve, nombre};
    return request(url, 'POST', body);
};

// Eliminar sublínea
export const eliminarSublinea = (url: string) => {
    return request(url, 'DELETE');
};

// Actualizar sublínea
export const actualizarSublinea = (url: string, cveLinea: string, cve: string, nombre: string) => {
    const body = {nombre};
    return request(url, 'PATCH', body);
};

// Obtener sublíneas
export const obtenerSublineas = (url: string) => {
    return request(url, 'GET');
};

export const obtenerProductos = (url: string) => {
    return request(url, 'GET');
};

// Obtener producto por cve
export const obtenerProductoPorCve = (cve: string) => {
    return request(`http://localhost:3000/producto/getProductoByCve/${cve}`, 'GET');
};

// Actualizar producto
export const actualizarProducto = (url: string, producto: any) => {
    return request(url, 'PATCH', producto);
};

// Eliminar producto
export const eliminarProducto = (url: string) => {
    return request(url, 'DELETE');
};

// Funciones para Entradas
export const registrarEntrada = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const obtenerEntradas = async (url: string) => {
    return request(url, 'GET');
};

export const actualizarEntrada = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const eliminarEntrada = async (url: string) => {
    return request(url, 'DELETE');
};

export const obtenerProveedores = async (url: string) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Error al obtener proveedores');
        }
        return await response.json();
    } catch (error) {
        console.error('Error en obtenerProveedores:', error);
        throw error;
    }
};
// Registrar un mantenimiento
export const registrarMantenimiento = (url: string, data: any) => {
    return request(url, 'POST', data);
};

// Obtener todos los mantenimientos
export const obtenerMantenimientos = (url: string) => {
    return request(url, 'GET');
};

// Obtener un mantenimiento por folio
export const obtenerMantenimientoPorFolio = (folio: string) => {
    return request(`http://localhost:3000/mantenimiento/getMantenimientoByFolio/${folio}`, 'GET');
};

// Actualizar un mantenimiento
export const actualizarMantenimiento = (url: string, folio: string, data: any) => {
    return request(`${url}/${folio}`, 'PUT', data);
};

// Eliminar un mantenimiento
export const eliminarMantenimiento = (url: string, folio: string) => {
    return request(`${url}/${folio}`, 'DELETE');
};

// Registrar un detalle de mantenimiento
export const registrarDetalleMantenimiento = (url: string, data: any) => {
    return request(url, 'POST', data);
};

// Eliminar un detalle específico de mantenimiento
export const eliminarDetalleMantenimiento = (url: string, folio: string, id: number) => {
    return request(`${url}/${folio}/${id}`, 'DELETE');
};

// Buscar detalles por folio
export const obtenerDetallesMantenimiento = (url: string, folio: string) => {
    return request(`${url}/${folio}/detalles`, 'GET');
};